/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { SET_SITE_META_INITIALIZE, SET_SITE_META_INFO } from '@naruto/bgdcms/src/reducers/cores/site-meta/actions';
import { errorCatch } from '@naruto/bgdcms/src/reducers/_Capture/errorCapture';
import { Dispatch, ThunkAction, Models, MiddleWare, SiteMetaInfo, SiteMetaUpdateData } from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postSiteMetaInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_SITE_META_INITIALIZE());
  };

/**
 * 取得網站元資訊
 */
export const getSiteMetaInfo =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.siteMeta.getSiteMeta<SiteMetaInfo>();
    if (!result.error && result.response) {
      dispatch(SET_SITE_META_INFO({ siteMetaInfo: result.response }));
    } else {
      const oldState = getState().siteMeta.siteMetaInfo;
      if (oldState) {
        dispatch(SET_SITE_META_INFO({ siteMetaInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_SITE_META_INFO({
            siteMetaInfo: {
              project_slots: []
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新網站元
 */
export const putSiteMeta =
  (
    siteMetaData: SiteMetaUpdateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.siteMeta.putSiteMeta<SiteMetaInfo, SiteMetaUpdateData>(siteMetaData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
